<template>
  <div id="app">

    <Head></Head>
    <div class="headline"></div>
    <router-view />

    <Foot></Foot>
    <div class="fixFloat"
         :class="$store.state.contFlag ? 'on' :''">
      <div class="fixBtn"
           @click="$store.commit('setStatus_contFlag')">
        <div v-if="!$store.state.contFlag">
          <van-icon name="arrow-left" />联系我们
        </div>
        <div v-else>
          <van-icon name="arrow" />点击关闭
        </div>
      </div>
      <div class="contact_box">
        <div class="contact_lis">
          <van-row>
            <van-col span="6">
              <div class="contact_aut">
                <div class="imgbox">
                  <img src="@/assets/01.png"
                       alt="">
                </div>
                <p>Catherine</p>
              </div>
            </van-col>
            <van-col span="12">
              <div class="contact_info">
                <h3>WeChat: <span>huya0126</span></h3>
                <h3>WhatsApp/Phone:</h3>
                <p>+86-10-62040776</p>
              </div>
            </van-col>
            <van-col span="6">
              <div class="contact_ewm">
                <div class="imgbox">
                  <img src="@/assets/kefu001.jpg"
                       alt="">
                </div>
              </div>
            </van-col>
          </van-row>
        </div>
        <div class="contact_lis">
          <van-row>
            <van-col span="6">
              <div class="contact_aut">
                <div class="imgbox">
                  <img src="@/assets/03.png"
                       alt="">
                </div>
                <p>Amira</p>
              </div>
            </van-col>
            <van-col span="12">
              <div class="contact_info">
                <h3>WeChat: <span>amiratxz</span></h3>
                <h3>WhatsApp/Phone:</h3>
                <p>+86-10-62040776</p>
              </div>
            </van-col>
            <van-col span="6">
              <div class="contact_ewm">
                <div class="imgbox">
                  <img src="@/assets/kefu003.jpg"
                       alt="">
                </div>
              </div>
            </van-col>
          </van-row>
        </div>
        <div class="contact_lis">
          <van-row>
            <van-col span="6">
              <div class="contact_aut">
                <div class="imgbox">
                  <img src="@/assets/02.png"
                       alt="">
                </div>
                <p>Audrey</p>
              </div>
            </van-col>
            <van-col span="12">
              <div class="contact_info">
                <h3>WeChat: <span>audrey_tang</span></h3>
                <h3>WhatsApp/Phone:</h3>
                <p>+86-10-62040776</p>
              </div>
            </van-col>
            <van-col span="6">
              <div class="contact_ewm">
                <div class="imgbox">
                  <img src="@/assets/kefu002.jpg"
                       alt="">
                </div>
              </div>
            </van-col>
          </van-row>
        </div>

      </div>
    </div>
  </div>
</template>
<script>
import Head from '@/components/Head.vue'
import Foot from '@/components/Foot.vue'

export default {
  components: {
    Head,
    Foot
  },
  data () {
    return {
      ckflage: false
    }
  },
}
</script>
<style lang="scss">
#app {
  font-family: "微软雅黑", "Microsoft YaHei", Avenir, Helvetica, Arial,
    sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #333;
}
html,
body,
div,
span,
p,
a,
img,
ul,
li,
form,
table,
tbody,
tr,
th,
td {
  margin: 0;
  padding: 0;
  border: 0;
  outline: 0;
}
body,
input,
textarea,
select,
button {
  font-synthesis: none;
  -moz-font-feature-settings: "kern";
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  direction: ltr;
  text-align: left;
}
html * {
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-rendering: optimizeLegibility;
  box-sizing: border-box;
}
body,
html {
  font-family: "微软雅黑", "Microsoft YaHei", "playfair_regular", Arial,
    "PingFangSC-Regular", "Helvetica", sans-serif;
  -webkit-tap-highlight-color: transparent;
  background-color: #fff;
  color: #000;
  -webkit-text-size-adjust: 100%;
  line-height: 1.4286;
}
li {
  list-style-type: none;
}
a {
  text-decoration: none;
  color: inherit;
  cursor: pointer;
}
a:active {
  cursor: pointer;
  -webkit-tap-highlight-color: rgba(0, 0, 0, 0);
}
input,
select {
  outline: none;
  -webkit-appearance: none;
  border: 0;
}
button {
  background: none;
  border: 0;
  outline: none;
  font-family: Arial, "PingFang", "Helvetica", sans-serif;
}
h3 {
  margin: 0;
}

.imgbox {
  display: flex;
  justify-content: center;
  align-items: center;
  overflow: hidden;
  position: relative;
  img {
    max-width: 100%;
  }
}

.container {
  padding: 0 25px;
}
.headTit {
  display: flex;
  justify-content: space-between;
  align-items: center;
  font-size: 40px;
  margin-bottom: 30px;
  .btns {
    width: 60px;
    height: 60px;
  }
}
.botline {
  text-align: center;
  font-size: 24px;
  padding: 40px 0;
  color: #f29810;
  border-bottom: 20px solid #dededd;
}
.nomore {
  text-align: center;
  font-size: 24px;
  margin: 40px 0;
  color: #f29810;
}
._box {
  position: relative;
  z-index: 99;
}

[class*="van-hairline"]::after {
  border-top: none;
}

.headline {
  height: 15px;
  background-color: #dededd;
}
.Index {
  margin-top: -15px;
}

.fixFloat {
  position: fixed;
  width: 640px;
  top: 50%;
  transform: translateY(-50%);
  right: -590px;
  display: flex;
  z-index: 1998;
  color: #fff;
  align-items: flex-end;
  transition: 0.5s ease;
  &.on {
    right: 0;
    .fixBtn {
      opacity: 1;
    }
  }
  .fixBtn {
    width: 50px;
    height: 250px;
    font-size: 30px;
    padding: 10px;
    background-color: #263e65;
    opacity: 0.8;
  }
  .contact_box {
    padding: 20px;
    width: calc(100% - 50px);
    background-color: #263e65;
  }
  .contact_lis {
    margin-bottom: 20px;
  }
  .contact_aut {
    img {
      width: 80px;
    }
    p {
      text-align: center;
    }
  }
  .contact_info {
    h3 {
      span {
        font-weight: normal;
      }
    }
  }
  .contact_ewm {
    img {
      width: 120px;
    }
  }
}
</style>
